import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { TEXT_FIELD_COLOR, TEXT_FIELD_VARIANT } from '../../enum/formProps';
import { ArticleValues } from '../../../../features/article/model/articleModel';
import CategorySelect from '../CategorySelect';
import * as CommonActions from '../../../../shared/redux/commonActions';

interface SelectProps {
  parentId?: number;
  categoryId?: number;
  readonly?: boolean;
  disabledCategoryOne?: boolean;
  removeCategoryThree?: boolean;
}

const CategoryFilter: React.FC<SelectProps> = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(CommonActions.getCategoriesList());
  }, []);

  return (
    <>
      <CategorySelect
        categoryId={props.categoryId}
        parent={() => {
          return props.parentId;
        }}
        readOnly={props.readonly}
        disabled={(name) => {
          return name === 'categoryOne' && props.disabledCategoryOne!;
        }}
        clearFieldsValue={(values, touched, setFieldValue, setFieldTouched) => {
          if (values.categoryTwo && touched.categoryOne) {
            setFieldValue('categoryTwo', {
              value: '',
              key: '',
            });
            setFieldTouched('categoryTwo', false);
          }
        }}
        clearFieldsDeps={(values) => {
          return values.categoryOne.key;
        }}
        name="categoryOne"
        label="article.category_one"
        color={TEXT_FIELD_COLOR.PRIMARY}
        variant={TEXT_FIELD_VARIANT.STANDARD}
      />
      <CategorySelect
        categoryId={props.categoryId}
        disabled={(name, values) => {
          return name === 'categoryTwo' && !values.categoryOne.key;
        }}
        parent={(values: ArticleValues) => {
          if (values.categoryOne.key) {
            return parseInt(values.categoryOne.key.replace(/[^\d.]/g, ''));
          }

          return undefined;
        }}
        clearFieldsValue={(values, touched, setFieldValue, setFieldTouched) => {
          if (values.categoryThree?.key && touched.categoryTwo) {
            setFieldValue('categoryThree', {
              value: '',
              key: '',
            });
            setFieldTouched('categoryThree', false);
          }
        }}
        clearFieldsDeps={(values) => {
          return values.categoryTwo.key;
        }}
        name="categoryTwo"
        label="article.category_two"
        color={TEXT_FIELD_COLOR.PRIMARY}
        variant={TEXT_FIELD_VARIANT.STANDARD}
      />
      {!props.removeCategoryThree && (
        <CategorySelect
          categoryId={props.categoryId}
          disabled={(name, values) => {
            return name === 'categoryThree' && !values.categoryTwo.key;
          }}
          parent={(values: ArticleValues) => {
            if (values.categoryTwo.key) {
              return parseInt(values.categoryTwo.key.replace(/[^\d.]/g, ''));
            }

            return undefined;
          }}
          name="categoryThree"
          label="article.category_three"
          color={TEXT_FIELD_COLOR.PRIMARY}
          variant={TEXT_FIELD_VARIANT.STANDARD}
        />
      )}
    </>
  );
};

export default CategoryFilter;
